import { ErrorObject } from '@vuelidate/core'

enum Validators {
    'REQUIRED' = 'required',
    'MIN_LENGTH' = 'minLength',
    'MAX_LENGTH' = 'maxLength',
    'MAX_VALUE' = 'maxValue',
    'INTEGER' = 'integer',
    'DECIMAL' = 'decimal',
    'EMAIL' = 'email',
    'URL' = 'url',
    'INCORRECT_SYMBOL' = 'incorrectSymbolValidator',
    'BIN' = 'binValidator',
    'INVOICE_FINDED' = 'invoice_finded',
    'IIN' = 'iinValidator',
    'SITE_LINK' = 'siteLink',
    'DATE_RANGE_MIN' = 'dateRangeMin',
    'POSITIVE' = 'positive'
}

enum Messages {
    'REQUIRED' = 'Обязательное поле',
    'MIN_LENGTH' = 'Слишком короткое значение',
    'MAX_LENGTH' = 'Превышено кол-во символов',
    'MAX_VALUE' = 'Превышено макс. значение',
    'INTEGER' = 'Только цифры',
    'DECIMAL' = 'Некорректное число',
    'EMAIL' = 'Некорректный e-mail',
    'URL' = 'Некорректный URL',
    'INCORRECT_SYMBOL' = 'Некорректное значение',
    'BIN' = 'Некорректный БИН',
    'INVOICE_FINDED' = 'Накладная не найдена',
    'IIN' = 'Некорректный ИИН',
    'SITE_LINK' = 'Некорректный адрес (например: spark.kz, https://spark.kz)',
    'DEFAULT' = 'Ошибка валидации',
    'DATE_RANGE_MIN' = 'Укажите обе даты',
    'POSITIVE' = 'Отрицательные числа запрещены'
}

export default function () {
    function getValidationMessage(errors: ErrorObject[]) {
        if (errors.length > 0) {
            switch (errors[0].$validator) {
                case Validators.REQUIRED:
                    return Messages.REQUIRED

                case Validators.MIN_LENGTH:
                    return Messages.MIN_LENGTH

                case Validators.MAX_LENGTH:
                    return Messages.MAX_LENGTH

                case Validators.MAX_VALUE:
                    return Messages.MAX_VALUE

                case Validators.EMAIL:
                    return Messages.EMAIL

                case Validators.URL:
                    return Messages.URL

                case Validators.INCORRECT_SYMBOL:
                    return Messages.INCORRECT_SYMBOL

                case Validators.BIN:
                    return Messages.BIN

                case Validators.INVOICE_FINDED:
                    return Messages.INVOICE_FINDED

                case Validators.IIN:
                    return Messages.IIN

                case Validators.INTEGER:
                    return Messages.INTEGER

                case Validators.SITE_LINK:
                    return Messages.SITE_LINK

                case Validators.DATE_RANGE_MIN:
                    return Messages.DATE_RANGE_MIN

                case Validators.POSITIVE:
                    return Messages.POSITIVE

                default:
                    return Messages.DEFAULT
            }
        }

        return null
    }

    return { getValidationMessage }
}
